module.exports = "<h1 mat-dialog-title>Acerca de</h1>\r\n<div mat-dialog-content>\r\n    <img src=\"assets/img/logo.png\" alt=\"\">\r\n</div>"